<template>
  <v-card-text>
    <v-card outlined :loading="loadingMain" :disabled="loadingMain">
      <v-toolbar flat>
        <v-toolbar-title>Planilha de Indexação</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" small dark fab v-bind="attrs" v-on="on">
              <v-icon>mdi-hammer-wrench </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="getExportExcel()">
              <v-list-item-title>
                <v-icon class="mr-2"> mdi-file-excel </v-icon>
                Exportar Excel
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-select
          clearable
          style="max-width: 500px"
          class="mt-6"
          rounded
          outlined
          dense
          item-value="id"
          v-model="selected_stages"
          :items="select_stages"
          label="Etapas"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name.substring(0, 30) }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selected_stages.length - 1 }} Outros)
            </span>
          </template>
        </v-select>
        <v-btn class="ml-4" color="primary" rounded @click="index()">Aplicar</v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn
          :loading="loadingSave"
          :disabled="loadingSave"
          rounded
          large
          color="primary"
          style="width: 150px"
          @click="save()"
        >
          Salvar</v-btn
        > -->
      </v-toolbar>

      <!-- ETAPAS  -->
      <div
        ref="tableWrapper"
        style="overflow: hidden; cursor: grab; user-select: none"
      >
      <v-simple-table
        dense
        style="border: 1px solid black"
        @mousedown.native="onDragStart"
      >
        <template v-slot:default>
          <thead>
            <tr style="background: #1976d2">
              <th
                class="text-left"
                style="width: 650px; border: 1px solid black; color: white"
                rowspan="2"
              >
                ETAPAS
              </th>
              <th rowspan="2" class="text-right" style="border: 1px solid black; color: white">
                ORÇAMENTO
              </th>
              <th rowspan="2" class="text-right" style="border: 1px solid black; color: white">
                REALIZADO
              </th>
              <th rowspan="2" class="text-right" style="border: 1px solid black; color: white">
                A REALIZAR
              </th>
              <th
                style="border: 1px solid black; color: white"
                v-for="(title, idx) in titles"
                :key="'title-' + idx"
                class="text-right"
              >
                {{ formatTitle(title) }}
              </th>
              <th rowspan="2" class="text-center" style="border: 1px solid black; color: white">
                TOTAL
              </th>
            </tr>
            <tr >

              <th
                style="border: 1px solid black; color: white"
                v-for="(index, idx) in indexes"
                :key="'title-' + idx"
                class="text-right"
              >

                <v-edit-dialog
                large
                  :return-value.sync="index.index"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  @save="save(index)"


        >
        <span style="color: blue;font-size:15px "> {{ formatMoney(index.index) }}  </span>
          <template v-slot:input>
            <vuetify-money
            v-model="index.index"
              :options="{
                prefix: '',
                thousands: '.',
                decimal: ',',
                precision: 2,
                masked: false
              }">

            </vuetify-money>

            <!-- <v-text-field
              v-model="index.index"
              :rules="[max25chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field> -->
          </template>
        </v-edit-dialog>
            </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in stages">
              <tr
                :key="index"
                :style="{
                  background: [
                    '#ffff99', // 1
                    '#b3c6e7', // 0
                    '#dbdbdb', // 2
                    '#ffe699', // 3
                    '#c5e0b4', // 4
                  ][index % 5],
                }"
              >
                <td style="border-top: 2px solid black;border-bottom: 2px solid black;border-left: 2px solid black" :rowspan="2">
                  <div style="width: 300px; word-wrap: break-word;">
                        {{  item.stage }}
                  </div>
                </td>
                <td style=" text-align:right;border-bottom: 0.5px solid black;border-top: 2px solid black;border-left: 0.5px solid black">
                    {{ item.total != 0 ? '100%' : "" }}
                </td>
                <td style="border-left: 0.5px solid black;border-top: 2px solid black;border-bottom: 0.5px solid black; text-align: right">
                  {{
                    item.expenses_paid_percentage != 0
                      ? formatMoney(item.expenses_paid_percentage)
                      : ""
                  }}

                </td>

                <td style="border-left: 0.5px solid black;border-top: 2px solid black;border-bottom: 0.5px solid black; text-align: right">
                  {{
                    item.a_realizar_percentage != 0
                      ? formatMoney(item.a_realizar_percentage)
                      : ""
                  }}

                </td>

                <td
                  :style="{ background: ite.index != 0 ? '' : 'white' }"
                  style="border-left: 0.5px solid black;border-top: 2px solid black;border-bottom: 0.5px solid black;"
                  class="text-right"
                  v-for="(ite, index) in item.data"
                  :key="'c-' +  index"
                >
                {{ ite.index != 0 ? formatMoney(ite.index) : "" }}

                </td>
                <td
                  :style="{ background: item.expenses_paid > item.total ? 'red' : '' }"
                  style="border-left: 0.5px solid black;border-top: 2px solid black; text-align: right;border-bottom: 0.5px solid black;border-right: 2px solid black"
                >
                 {{ item.sum_total != 0 ? formatMoney(item.sum_total) : "" }}

                </td>
              </tr>
              <tr
                :style="{
                  background: [
                    '#ffff99', // 1
                    '#b3c6e7', // 0
                    '#dbdbdb', // 2
                    '#ffe699', // 3
                    '#c5e0b4', // 4
                  ][index % 5],
                }"
                :key="'c1-' + item.id + index"
              >
                <td style="border-left: 0.5px solid black;border-bottom: 2px solid black" class="text-right">
                    {{ item.budget != 0 ? formatMoney(item.budget) : "" }}
                </td>
                <td style="border-left: 0.5px solid black;border-bottom: 2px solid black" class="text-right">
                    {{ item.expenses != 0 ? formatMoney(item.expenses) : "" }}
                </td>

                <td style="border-left: 0.5px solid black;border-bottom: 2px solid black" class="text-right">
                    {{ item.balance != 0 ? formatMoney(item.balance) : "" }}
                </td>

                <td
                  :style="{ background: ite.value != 0 ? '' : 'white' }"
                  style="border-left: 0.5px solid black;border-bottom: 2px solid black"
                  class="text-right"
                  v-for="(ite, index) in item.data"
                  :key="'p-' + index"
                >

                    {{ ite.value != 0 ? formatMoney(ite.value)  : "" }}
                </td>

                <td
                  :style="{ background: item.expenses_paid > item.total ? 'red' : '' }"
                  style="border-left: 0.5px solid black;border-right: 2px solid black;border-bottom: 2px solid black; text-align: right"
                >
                   {{
                    item.sum_total_percentage != 0
                      ? formatMoney(item.sum_total_percentage)+"%"
                      : ""
                  }}
                </td>
              </tr>
            </template>
            <tr>
              <td></td>
            </tr>
          </tbody>
          <tfoot>
            <tr style="background: lightgray">
              <th style="border: 1px solid black" rowspan="3" class="text-center">
                <b>SUB-TOTAL</b>
              </th>
              <th style="border: 1px solid black" class="text-right">ORÇAMENTO</th>
              <th style="border: 1px solid black" class="text-right">REALIZADO</th>
              <th style="border: 1px solid black" class="text-right">A REALIZAR</th>
              <th
                style="border: 1px solid black"
                v-for="(title, idx) in titles"
                :key="'foot-' + idx"
                class="text-right"
              >
                {{ formatTitle(title) }}
              </th>
              <th style="border: 1px solid black; text-align: center">TOTAL</th>
            </tr>
            <tr style="background: lightgray">
              <td style="border: 1px solid black; text-align: right">{{ formatMoney(subtotal.orcamento) }}</td>
              <td style="border: 1px solid black; text-align: right">
                {{ formatMoney(subtotal.realizado) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ formatMoney(subtotal.a_realizar) }}

              </td>
              <td
                style="border: 1px solid black"
                v-for="(subtotal, idx) in subtotal.subtotal_data"
                :key="'foot-' + idx"
                class="text-right"
              >
              {{ formatMoney(subtotal.value) }}

              </td>
              <td style="border: 1px solid black; text-align: right">
                {{formatMoney(subtotal.sum_total)}}
              </td>
            </tr>
            <tr style="background: lightgray">
              <td style="border: 1px solid black; text-align: right">
                100%
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ formatMoney(subtotal.realizado_percentage) }}%
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ formatMoney(subtotal.a_realizar_percentage) }}%
              </td>
              <td
                style="border: 1px solid black"
                v-for="(subtotal, idx) in subtotal.subtotal_data"
                :key="'foot-' + idx"
                class="text-right"
              >
                {{ formatMoney(subtotal.index) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ formatMoney(subtotal.sum_total_percentage) }}%
              </td>
            </tr>
          </tfoot>
        </template>
      </v-simple-table>
      </div>
    </v-card>
    <!-- Dialog for scheduling service -->
    <!-- <DialogScheduleService
      v-model="dialog_schedule_service"
      @updatePhysicalSchedule="updatePhysicalSchedule"
      :physical_schedule="physical_schedule"
    /> -->
  </v-card-text>
</template>

<script>
import { mapActions } from "vuex";
// import DialogScheduleService from "./components/DialogScheduleService.vue";
export default {
  components: {
    // DialogScheduleService,
  },
  data() {
    return {
      selected_stages: [],
      select_stages: [],

      physical_schedule: null,
      selectedComposition: null,
      selectedStage: null,
      loadingMain: false,
      loadingSave: false,
      dialog_schedule_service: false,
      stages: [],
      titles: [],
      indexes: [],
      subtotal: {
        orcamento: 0,
        realizado: 0,
        a_realizar: 0,
      },
      isDragging: false,
      startX: 0,
      scrollStart: 0,
      startY: 0,
      scrollStartTop: 0,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("IndexingSpreadsheet", [
      "getIndexingSpreadsheet",
      "getExportsSyntheticExcel",
      "loadSelectStages",
      "saveIndex",
    ]),
    initialize() {
      //carrega os items do select stages
      this.loadingSelectStages = true;
      this.loadSelectStages()
        .then((response) => {
          this.select_stages = response.data;
        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar as etapas do select");
        })
        .finally(() => {
          this.loadingSelectStages = false;
        });

      this.index();
    },
    index() {
      let stages_ids = this.selected_stages.join(",");
      this.loadingMain = true;
      this.getIndexingSpreadsheet(stages_ids)
        .then((response) => {
          this.stages = response.data.stages;
          this.titles = response.data.titles;
          this.subtotal = response.data.subtotal;
          this.indexes = response.data.indexes;

        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar as etapas");
        })
        .finally(() => {
          this.loadingMain = false;
        });
    },


    /**
     * salva o indice
     */
    save(index) {
      this.loadingSave = true;

      this.saveIndex(index).then((response)=>{
          this.$toast.success("Índice salvo !");
          let data = response.data;

          this.calcIndexExpenses(data.index, data.month)
       // this.initialize();
      }).catch((error)=>{
        console.log(error);
        this.$toast.error("Não foi possível salvar o índice");
      }).finally(()=>{
        this.loadingSave = false;
      });
    },


    /**
     * Calcula os indices de despesas indexadas
     * @param index indice
     * @param month mes
     */
    calcIndexExpenses(index, month) {
       this.stages.forEach((stage) => {
            stage.data[month].index = stage.data[month].value / index;

       });
    },



//somatorio de hh total de cada etapa
    calcSumHHTotal(stage) {
      //somatorio da coluna hh_total
      return stage.reduce((acc, item) => {
        return acc + item.hh_total;
      }, 0);
    },
    //somatorio de a realizar de cada etapa
    calcSumARealizar(stage) {
      //somatorio da coluna hh_a_realizar
      return stage.reduce((acc, item) => {
        return acc + item.a_realizar;
      }, 0);
    },
    /**
     * Exporta para Excel
     */

    getExportExcel() {

      let stages_ids = this.selected_stages.join(",");
      this.getExportsSyntheticExcel(stages_ids).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "export.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
      this.$toast.success("Gerando exportação em excel!");
    },

    getScrollContainer() {
      const table = this.$refs.tableWrapper;
      if (!table) return null;
      return table.querySelector('.v-data-table__wrapper') || table;
    },
    onDragStart(e) {
      e.preventDefault();
      const container = this.getScrollContainer();
      if (!container) return;
      this.isDragging = true;
      this.startX = e.pageX;
      this.scrollStart = container.scrollLeft;
      this.startY = e.pageY;
      this.scrollStartTop = container.scrollTop;
      container.style.cursor = 'grabbing';
      const onMove = (ev) => {
        if (!this.isDragging) return;
        ev.preventDefault();
        const deltaX = ev.pageX - this.startX;
        const deltaY = ev.pageY - this.startY;
        container.scrollLeft = this.scrollStart - deltaX;
        container.scrollTop = this.scrollStartTop - deltaY;
      };
      const onEnd = () => {
        this.isDragging = false;
        container.style.cursor = 'grab';
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onEnd);
    },

    formatTitle(title){
            let title_split = title.split("-");
            return title_split[1] + "/" + title_split[0];
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
    formatDate(date) {
      if (date) {
        let date_split = date.split("-");
        return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
      return "";
    },
    stringLong(composition_name) {
      if (composition_name.length > 150) {
        return "...";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.title_table {
  font-size: 16px;
  margin-top: 20px;
  width: 100%;
  height: 32px;
  background: #1976d2;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  padding-top: 3px;
}
</style>

<style>
.v-data-table__wrapper {
  max-height: calc(100vh - 150px);
  overflow-y: auto !important;
}
</style>
